<template>
	<div id="content" class="no-spacing">
		<div class="wrapper">
			<h1>Hier finden Sie uns.</h1>
			<p><b>A40-Ausfahrt "Mülheim Styrum" &rarr; Richtung Mülheim &rarr; nach 100 Metern auf der rechten Seite (Haltestelle Willy-Brand-Schule)</b></p>
			<!-- <p>
				Car-Markt / Fa. Mark Purushotham<br />
				<a href="https://goo.gl/maps/VeF8H77UpLVgqjPk7" target="_blank">Rüttenscheider Str. 325-327<br>45131 Essen</a>
			</p> -->
			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2487.978982161261!2d6.99949025153571!3d51.42181272467806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8c24ed14a0a49%3A0x83f3e9b09ac6ecd3!2sCar-Markt+(Fa.+Purushotham)!5e0!3m2!1sde!2sde!4v1559306086550!5m2!1sde!2sde" frameborder="0" style="border:0" allowfullscreen></iframe>
		</div>
	</div>
</template>

<style lang="scss" scoped>
iframe {
	width: 100%;
	min-height: 400px;
	height: calc(100vh - 300px);
}
</style>

<script>
export default {
	name: 'Location'
}
</script>
